export default {
    initEnvironment: () => {
        return {
            url: '/fhepool/initialize',
            method: 'GET'
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/api.js